import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminEchomapUhd293sv = () => {
  // Get the product data directly from screensData
  const productId = "echomap-93sv-uhd2";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminEchomapUhd293sv - Direct Import - Product Data:', productData);
  console.log('GarminEchomapUhd293sv - Direct Import - Image URL:', productData?.image);
  
  // Use the direct image URL provided
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-echomap-uhd2-93sv.jpg";
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-93sv-uhd2"
      productName="Garmin ECHOMAP UHD2 93sv"
      productImage={imageUrl}
    />
  );
};

export default GarminEchomapUhd293sv; 